import { render, staticRenderFns } from "./OrderedComplete.vue?vue&type=template&id=735e1fb8&scoped=true&"
import script from "./OrderedComplete.vue?vue&type=script&lang=js&"
export * from "./OrderedComplete.vue?vue&type=script&lang=js&"
import style0 from "./OrderedComplete.vue?vue&type=style&index=0&id=735e1fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735e1fb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
